module.exports = __webpack_public_path__ + "img/resp-sidebar-open.ed4f462a.svg";